import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./Edufin.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import edufinLogo from "../../../../../assets/images/edufinLogo.svg";
import { useNavigate } from "react-router-dom";
import edufinEdit from "../../../../../assets/images/edufinEdit.svg";
import edufinDown from "../../../../../assets/images/edufinDown.svg";
import CustomDropdown from "../../../Manage/Notification/CustomDropDown";
import AccordionForCourse from "./AccordionForCourse";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import EdufinIntegrateModal from "./EdufinIntegrateModal";
import Delete from "../../../../../assets/images/delete-dustbin.svg";
import addPlus from "../../../../../assets/images/addPlus.svg";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { findBranchById } from "../../../../../components/CommonFunctions/CommonFunctions";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import { DownloadEdufin } from "../../service/integrations.request";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import { useDispatch } from "react-redux";
import EdufinSkeleton from "../../../../../components/Skeletons/EdufinSkeleton";
import DeletePopupForEdufin from "./DeletePopupForEdufin";
import { resetEdufinDeleteSuccess } from "../../service/EdufinSlice";

const DraftSavedEdufinBranchesList = (props: any) => {
  const {
    DeleteEdufin,
    // DownloadEdufin,
    GetEdufinData,
    edufinData,
    edufinDataLoading,
    deleteEdufinLoading,
    deleteEdufinSuccess,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [showIcons, setShowIcons] = useState(true);
  const [value, setValue] = useState<number>(0);
  const auth = useAuthUser();
  const authUser = auth();
  const [edufinDataState, setEdufinDataState] = useState<any>(null);
  const [selectedBranch, setSelectedBranch] = useState<any>("");
  const [idForDeletion, setIdForDeletion] = useState<any>("");

  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;
  const branches = useSelector((state: any) => state.branch.branchList);

  React.useEffect(() => {
    if (instituteDetails) {
      const body = {
        instituteId: instituteDetails?.id,
      };
      GetEdufinData(body);
    }
  }, []);

  useEffect(() => {
    if (edufinData) {
      setEdufinDataState(edufinData);
      setSelectedBranch(edufinData?.[0]?.id);
    }
  }, [edufinData]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleTabSelect = (branchId: string) => {
    if (!branchId) return;
    setSelectedBranch(branchId);
  };

  const base64ToBlob = (base64Data: string, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const handleDownload = (item: any) => {
    const data = {
      action: "DOWNLOAD",
      instituteId: item?.instituteId,
      branchId: item?.branchId,
      id: item?.id,
    };
    DownloadEdufin(data)
      .then((res: any) => {
        const blob: any = base64ToBlob(
          res?.data?.data?.fileBase64String,
          "application/vnd.ms-excel"
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const branchesArr = item?.branches || [];
        const firstBranchName = branchesArr[0]?.branchName || "Branch";
        const fileName =
          branchesArr.length > 1
            ? `${firstBranchName}+${branchesArr.length - 1}`
            : firstBranchName;

        link.download = `${fileName}.xlsx`;
        // link.download = `${item?.loanApplicationData?.instituteDetail?.branchName}.xlsx`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        dispatch(
          setToastNotification({
            message:
              "Congratulations! Edufin Document successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
      })
      .catch((err: any) => {});
  };

  const handleDelete = (id: string) => {
    setIsOpen(true);
    setIdForDeletion(id);
  };

  const handleEdit = (d: any) => {
    navigate(`/app/Integrations/EdufinDetails?id=${d?.id}`);
    localStorage.setItem("idForEdufinForm", d?.id);
  };

  const handlePopupYesButton = () => {
    DeleteEdufin(idForDeletion);
    setIdForDeletion("");
    setIsOpen(false);
  };

  const handlePopupNoButton = () => {
    setIdForDeletion("");
    setIsOpen(false);
  };

  useEffect(() => {
    if (deleteEdufinSuccess === true) {
      const body = {
        instituteId: instituteDetails?.id,
      };
      GetEdufinData(body);
      dispatch<any>(resetEdufinDeleteSuccess());
    }
  }, [deleteEdufinSuccess]);

  return (
    <>
      <Box
        sx={{
          overflow: "hidden",
          padding: "14px 16px",
          background: "#EEEEEE",
          maxHeight: "calc(100vh - 65px)",
          position: "relative",
        }}
      >
        {edufinDataLoading ? (
          <EdufinSkeleton />
        ) : (
          <Box
            sx={{
              // overflow: "scroll",
              background: "#fff",
              border: "1px solid #E9E9E9",
              borderRadius: "8px",
              // minHeight: "calc(100vh - 93px)",
              // maxHeight: "calc(100vh - 93px)",
            }}
          >
            <div
              className={styles.nurtureDetailsSplit}
              style={{
                minHeight: "calc(100vh - 110px)",
                maxHeight: "calc(100vh - 110px)",
              }}
            >
              <div
                style={{
                  padding: "27px 20px 20px 20px",
                }}
              >
                <button
                  className={styles.PageBackBtn}
                  onClick={() => navigate(`/app/Integrations`)}
                >
                  <ArrowBackIcon
                    sx={{
                      marginRight: "8px",
                      fontSize: "15PX",
                      color: "#667085",
                    }}
                  />
                  Back
                </button>
                <div className={styles.buttonsGroup}>
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    aria-label="billing tabs"
                    sx={{
                      ml: 2,
                      backgroundColor: "white",
                      // height: "36px",
                      // minHeight: "36px",
                      minHeight: "60px",
                      "& .MuiTabs-flexContainer": {
                        gap: "24px",
                      },
                      "& .MuiTabs-indicator": {
                        height: "2.5px",
                      },
                    }}
                  >
                    {edufinDataState &&
                      edufinDataState?.map((d: any) => {
                        const branchesArr = d?.branches || [];
                        const firstBranchName =
                          branchesArr[0]?.branchName || "Unknown";
                        const label =
                          branchesArr.length > 1
                            ? `${firstBranchName}+${branchesArr.length - 1}`
                            : firstBranchName;
                        return (
                          <Tab
                            label={label}
                            {...a11yProps(0)}
                            sx={{
                              textTransform: "capitalize",
                              padding: "0",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "24px",
                              color: "#142C4480",
                              minWidth: "fit-content",
                              // height: "36px",
                              // minHeight: "36px",
                              minHeight: "60px",
                              "&.Mui-selected": {
                                color: "#142C44",
                                fontWeight: "700",
                              },
                            }}
                            onClick={() => {
                              handleTabSelect(d?.id);
                            }}
                          />
                        );
                      })}
                  </Tabs>
                  <div
                    className={styles.addNew}
                    onClick={() => {
                      navigate(`/app/Integrations/EdufinDetails`);
                      localStorage.setItem("idForEdufinForm", "");
                    }}
                  >
                    <img
                      src={addPlus}
                      style={{ marginRight: "5px", height: "15px" }}
                    />
                    Add New
                  </div>
                </div>

                <div className={styles.editSection}>
                  <div className={styles.edufinTitleSection}>
                    <div className={styles.title}>
                      Education Loan Application Powered by EduFin
                    </div>
                    <div className={styles.subTitle}>
                      <img src={edufinLogo} />
                      Powered by EduFin
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={styles.nurtureDetailsSplitLeft}
                style={{
                  width: "100%",
                  overflow: "scroll",
                  background: "#fff",
                  // border: "1px solid #E9E9E9",
                  // borderRadius: "8px",
                  minHeight: "calc(100vh - 250px)",
                  maxHeight: "calc(100vh - 250px)",
                }}
              >
                <div className={styles.PageBackBtnWrap}>
                  {edufinDataState && edufinDataState?.length > 0 ? (
                    edufinDataState
                      ?.filter((d: any) => {
                        return d?.id === selectedBranch;
                      })
                      ?.map((d: any) => {
                        const {
                          bankDetail,
                          contactDetail,
                          courseDetail,
                          instituteDetail,
                          instituteInfo,
                        } = d?.loanApplicationData;
                        return (
                          <>
                            <div className={styles.savedContainer}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className={styles.sectionHeader}>
                                  Institute Details
                                </div>
                                {showIcons === true ? (
                                  <div className={styles.iconContainer}>
                                    <div
                                      className={styles.iconBox}
                                      onClick={() => handleDownload(d)}
                                    >
                                      <img
                                        src={edufinDown}
                                        height={"30px"}
                                        width={"30px"}
                                      />
                                    </div>
                                    <div
                                      className={styles.iconBox}
                                      onClick={() => handleEdit(d)}
                                    >
                                      <img
                                        src={edufinEdit}
                                        height={"20px"}
                                        width={"20px"}
                                      />
                                    </div>
                                    <div
                                      className={styles.iconBox}
                                      onClick={() => handleDelete(d?.id)}
                                    >
                                      <img
                                        src={Delete}
                                        height={"20px"}
                                        width={"20px"}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div className={styles.iconContainer}>
                                    <div
                                      className={styles.iconBox}
                                      onClick={() => handleDelete(d?.id)}
                                    >
                                      <img
                                        src={Delete}
                                        height={"20px"}
                                        width={"20px"}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Institute Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.instituteName}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Institute Branch Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.branches
                                      ?.map((d: any) => d?.branchName)
                                      .join(", ")}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Institute Type :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.instituteType}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    City :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.city
                                      ? instituteDetail?.city
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    State :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.state
                                      ? instituteDetail?.state
                                      : "-"}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Pincode :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.pincode}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Operation Since :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.operationSince}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Average Fees :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.averageFees}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Student Strength :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.studentStrength}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Teachers Strength :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.teacherStrength}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Affiliation Code :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.affiliationCode
                                      ? instituteDetail?.affiliationCode
                                      : "-"}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Board :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteDetail?.board
                                      ? instituteDetail?.board
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div
                                  className={styles.savedInfoRowContentAddress}
                                >
                                  <div className={styles.subSectionKey}>
                                    Address :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {` ${instituteDetail?.address}`}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.savedContainer}>
                              <div className={styles.sectionHeader}>
                                Contact Information
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Principal Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {contactDetail?.principalName}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Principal Contact No :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {/* {contactDetail?.principalNumber} */}
                                    {contactDetail?.principalNumber &&
                                    typeof contactDetail?.principalNumber ===
                                      "string"
                                      ? ` +${
                                          contactDetail?.contactCountryCode ||
                                          "91"
                                        } ${
                                          contactDetail?.principalNumber?.startsWith(
                                            contactDetail?.contactCountryCode ||
                                              "91"
                                          )
                                            ? contactDetail?.principalNumber?.replace(
                                                contactDetail?.contactCountryCode ||
                                                  "91",
                                                ""
                                              )
                                            : contactDetail?.principalNumber
                                        }`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    SPOC Person Name:
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {contactDetail?.spocPersonName}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    SPOC Person No :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {/* {contactDetail?.spocPersonNumber} */}
                                    {contactDetail?.spocPersonNumber &&
                                    typeof contactDetail?.spocPersonNumber ===
                                      "string"
                                      ? ` +${
                                          contactDetail?.contactCountryCodeForSPOC ||
                                          "91"
                                        } ${
                                          contactDetail?.spocPersonNumber?.startsWith(
                                            contactDetail?.contactCountryCodeForSPOC ||
                                              "91"
                                          )
                                            ? contactDetail?.spocPersonNumber?.replace(
                                                contactDetail?.contactCountryCodeForSPOC ||
                                                  "91",
                                                ""
                                              )
                                            : contactDetail?.spocPersonNumber
                                        }`
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    SPOC Person Email ID :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {contactDetail?.spocPersonEmail}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Accounts Team Email ID :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {contactDetail?.accountEmail}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.savedContainer}>
                              <div className={styles.sectionHeader}>
                                Bank Details
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Bank Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.bankName}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Bank Account No :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.bankAccountNumber}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    IFSC Code :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.ifscCode}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div>Account Type :</div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.accountType}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Beneficiary Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.beneficiaryName}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Website/Social Media :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {bankDetail?.website
                                      ? bankDetail?.website
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={styles.savedContainer}>
                              <div className={styles.sectionHeader}>
                                Institute Details
                              </div>
                              <div className={styles.savedInfoRow}>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Institute Name :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteInfo?.instituteName
                                      ? instituteInfo?.instituteName
                                      : "-"}
                                  </div>
                                </div>
                                <div className={styles.savedInfoRowContent}>
                                  <div className={styles.subSectionKey}>
                                    Type :
                                  </div>
                                  <div className={styles.subSectionValue}>
                                    {instituteInfo?.instituteType
                                      ? instituteInfo?.instituteType
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {courseDetail && courseDetail?.length > 0 && (
                              <div
                                className={styles.savedContainer}
                                style={{ marginBottom: "50px" }}
                              >
                                <div
                                  style={{ marginBottom: "15px" }}
                                  className={styles.sectionHeader}
                                >
                                  Courses
                                </div>
                                {courseDetail?.map((d: any, i: number) => {
                                  return (
                                    <div
                                      className={
                                        styles.savedInfoRowForCourseDetails
                                      }
                                    >
                                      <AccordionForCourse item={d} index={i} />
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </>
                        );
                      })
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className={styles.savedContainer}
                        style={{
                          color: "rgba(20, 44, 68, 1)",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        No Application available.Please create new one.
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className={styles.buttonContainer}>
                <SaveBtn
                  buttonText={"Integrate Edufin"}
                  onClick={() => handleClickOpen()}
                />
              </div> */}
              </div>
            </div>
          </Box>
        )}
        <EdufinIntegrateModal open={open} setOpen={setOpen} />
        <DeletePopupForEdufin
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handlePopupYesButton={handlePopupYesButton}
          handlePopupNoButton={handlePopupNoButton}
          loading={deleteEdufinLoading}
        />
      </Box>
    </>
  );
};

export default DraftSavedEdufinBranchesList;
